import { render, staticRenderFns } from "./InstantOrders.vue?vue&type=template&id=1feddab8&scoped=true"
import script from "./InstantOrders.vue?vue&type=script&lang=js"
export * from "./InstantOrders.vue?vue&type=script&lang=js"
import style0 from "./InstantOrders.vue?vue&type=style&index=0&id=1feddab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feddab8",
  null
  
)

export default component.exports